export enum UserType {
  USER = 'usuario',
  CLIENTE = 'cliente',
}
